(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/oddset-common/assets/javascripts/oddset-common.js') >= 0) return;  svs.modules.push('/components/sport/oddset-common/assets/javascripts/oddset-common.js'); 
'use strict';

var svs = svs || global.svs || {};

(function(svs) {
  var logger, trinidad;

  if (svs.isServer) {
    require('trinidad-core').core.components.require('racing', 'common');

    trinidad = require('trinidad-core').core;

    svs.oddset = svs.oddset || {};
    svs.oddset.utils = svs.oddset.utils || {};
    svs.oddset.utils = trinidad.components.require(
      'sport',
      'oddset-utils'
    ).utils;

    svs.utils = svs.utils || {};
    svs.utils.url = trinidad.components.require('utils', 'url').api;

    logger = trinidad.logger('sport:oddset-common');
  } else {
    logger = new svs.core.log.Logger('sport:oddset-common');
  }

  svs.sport = svs.sport || {};
  svs.sport.oddsetCommon = svs.sport.oddsetCommon || {};

  svs.sport.oddsetCommon.Common = function() {
    var EVENT_TYPE_ID_WHITE_LIST = [
        1, 
        31 
      ],
      SUB_TYPE_ID_WHITE_LIST = [
        { eventSubTypeId: 2, refundIfTie: false, enabled: true }, 
        { eventSubTypeId: 3, refundIfTie: false, enabled: true }, 
        { eventSubTypeId: 4, refundIfTie: false, enabled: true } 
      ];

    function getMostPlayedDrawEvents(options, callback) {
      getPopularDraws(options, function(error, draws) {
        var i = 0;

        if (error) {
          logger.error('Failed to fetch draw by match id: ' + error);
          callback(error, null);
        } else if (draws) {
          var length = draws.length;

          var populateDraw = function(draw, callback) {
            getEventFromDraw(draw, function(error) {
              if (error) {
                logger.warn(error);
                draws[i] = null;
              } else {
                draws[i] = formatDrawData(draw);
              }

              i++;
              if (i < length) {
                populateDraw(draws[i], callback);
              } else {
                callback(error, draws);
              }
            });
          };

          populateDraw(draws[i], callback);
        } else {
          callback(error);
        }
      });
    }

    function getDrawEvent(options, callback) {
      getDrawByMatchId(options, function(error, draw) {
        if (error) {
          logger.error('Failed to fetch draw by match id: ' + error);
          callback(error, null);
        } else if (draw) {
          var eventFromDrawHandler = function(error) {
            if (error) {
              logger.warn(error);
              callback(error, null);
            } else {
              callback(error, formatDrawData(draw));
            }
          };
          getEventFromDraw(draw, eventFromDrawHandler);
        } else {
          callback(error);
        }
      });
    }

    function validateEvenTypeId(eventTypeId) {
      return EVENT_TYPE_ID_WHITE_LIST.indexOf(eventTypeId) !== -1;
    }

    function getEventFromDraw(draw, callback) {
      var events;

      if (!draw || draw && !Array.isArray(draw.events)) {
        callback('draw.events is not an array, it is: ' + typeof draw.events);
      } else {
        events = tryFindAvailableEvents(draw.events);
        if (events.length === 0) {
          callback(
            'No event found with the supported eventTypeId, eventSubTypeId or refundIfTie'
          );
        } else {
          callback(null, events[0]);
        }
      }
    }

    function tryFindAvailableEvents(possibleEvents, sub) {
      var events = [],
        i = -1;

      if (sub) {
        possibleEvents = possibleEvents.filter(function(event) {
          return event.isListEvent && validateEvenTypeId(event.eventTypeId);
        });
      } else {
        possibleEvents = possibleEvents.filter(function(event) {
          return validateEvenTypeId(event.eventTypeId);
        });
      }

      while (i++ < SUB_TYPE_ID_WHITE_LIST.length - 1) {
        events = where(possibleEvents, SUB_TYPE_ID_WHITE_LIST[i]);
        if (events.length > 0) {
          break;
        }
      }
      return events;
    }

    function getPopularDraws(options, callback) {
      var jupiterOptions = {
        method: 'GET',
        path: '/draw/oddset/draws?selection=hot&offset=0&count=0'
      };

      if (svs.isServer) {
        jupiterOptions.req = options.req;
      }

      try {
        var responseHandler = function(err, data) {
          if (err) {
            callback(err);
          } else {
            if (data && data.draws) {
              callback(null, data.draws);
            } else {
              logger.debug('No draws in data response', options.req);
              callback(null, null);
            }
          }
        };

        if (svs.isServer) {
          trinidad.jupiter.call(jupiterOptions, responseHandler);
        } else {
          svs.core.jupiter.call(
            jupiterOptions,
            function(response) {
              responseHandler(null, response);
            },
            function(xhr) {
              responseHandler(xhr);
            }
          );
        }
      } catch (e) {
        callback(e);
      }
    }

    function getDrawByMatchId(options, callback) {
      var jupiterOptions = {
        method: 'GET',
        path:
          '/search/query/?ctx=draw&type=oddsetlist&andfilter=payload.draw.match.matchId;'
      };
      jupiterOptions.path += options.matchId; 

      if (svs.isServer) {
        jupiterOptions.req = options.req;
      }

      try {
        var responseHandler = function(err, data) {
          if (err) {
            callback(err);
          } else {
            if (data && data.result && data.result.length > 0) {
              callback(null, data.result[0].payload.draw);
            } else {
              logger.debug('No draws in data response', options.req);
              callback(null, null);
            }
          }
        };

        if (svs.isServer) {
          trinidad.jupiter.call(jupiterOptions, responseHandler);
        } else {
          svs.core.jupiter.call(
            jupiterOptions,
            function(response) {
              responseHandler(null, response);
            },
            function(xhr) {
              responseHandler(xhr);
            }
          );
        }
      } catch (e) {
        callback(e);
      }
    }

    function formatDrawData(draw, sub) {
      if (draw.match) {
        draw.match.participants = draw.match.participants || [];
        var hasLeague = Boolean(draw.league),
          event = tryFindAvailableEvents(draw.events, sub)[0] || {
            outcomes: []
          },
          result = svs.oddset.utils.result(draw.match),
          oddsData = getOddsDataFromEvent(event, draw),
          retVal = {
            isLive: draw.categoryId === 2 && Boolean(result), 
            hasLeague: hasLeague,
            leagueName: hasLeague ? draw.league.name : null,
            participant_a:
              draw.match.participants.length > 0
                ? draw.match.participants[0].name
                : null,
            participant_a_short:
              draw.match.participants.length > 0
                ? draw.match.participants[0].mediumName
                : null,
            participant_b:
              draw.match.participants.length > 1
                ? draw.match.participants[1].name
                : null,
            participant_b_short:
              draw.match.participants.length > 1
                ? draw.match.participants[1].mediumName
                : null,
            score_a: result ? result.home : 0,
            score_b: result ? result.away : 0,
            event: event,
            draw: draw,
            moreEventTypes: draw.eventCount - 1 > 0,
            moreEventTypesCount: draw.eventCount - 1,
            currentOdds: oddsData.currentOdds,
            outcomeDescriptions: oddsData.outcomeDescriptions,
            url:
              '/oddset/' +
              draw.id +
              '-' +
              svs.utils.url.encode(draw.description)
          };

        formatOutcomes(draw.events);

        return retVal;
      }
      return null;
    }

    function formatOutcomes(events) {
      if (events.length > 0 && events[0].outcomes.length > 0) {
        var outcomes = events[0].outcomes[0];

        if (
          outcomes.items.length === 2 &&
          outcomes.items[0].description === '1'
        ) {
          outcomes.items.splice(1, 0, {
            description: 'X',
            enabled: true,
            odds: '0,00',
            oddsChanged: false,
            outcomeNumber: 0,
            isZero: true
          });
        }
      }
    }

    var where = function(obj, attrs) {
      var keys = Object.keys(attrs),
        validate = false,
        result = [];

      if (Array.isArray(obj) && Array.isArray(keys) && keys.length > 0) {
        result = obj.filter(function(item) {
          keys.every(function(key) {
            validate = false;
            if (item[key] === attrs[key]) {
              validate = true;
            }
            return validate;
          });
          return validate;
        });
      }
      return result;
    };

    function getOddsDataFromEvent(event, draw) {
      var index = 0,
        currentOdds = [],
        outcomeDescriptions = [];

      event.outcomes.forEach(function(outcome, outcomeIndex) {
        if (outcome && outcome.items && Array.isArray(outcome.items)) {
          outcome.items.forEach(function(item, itemIndex) {
            currentOdds.push(
              event.outcomes[outcomeIndex].items[itemIndex].odds
            );

            outcomeDescriptions.push(
              event.outcomes[outcomeIndex].items[itemIndex].description
            );
            event.outcomes[outcomeIndex].items[itemIndex].index = index++;

            if (event.outcomes[outcomeIndex].items[itemIndex].odds === '0,00') {
              event.outcomes[outcomeIndex].items[itemIndex].isZero = true;
            }

            if (
              !draw.enabled ||
              !event.enabled ||
              event.outcomes[outcomeIndex].items[itemIndex].odds === '1,00'
            ) {
              event.outcomes[outcomeIndex].items[itemIndex].enabled = false;
            }
          });
        }
      });

      return {
        currentOdds: currentOdds,
        outcomeDescriptions: outcomeDescriptions
      };
    }

    return {
      getDrawByMatchId: getDrawByMatchId,
      getDrawEvent: getDrawEvent,
      getOddsDataFromEvent: getOddsDataFromEvent,
      formatDrawData: formatDrawData,
      getMostPlayedDrawEvents: getMostPlayedDrawEvents
    };
  };

  svs.sport.oddsetCommon.common = new svs.sport.oddsetCommon.Common();

  if (svs.isServer) {
    module.exports = {
      getDrawEvent: svs.sport.oddsetCommon.common.getDrawEvent,
      getMostPlayedDrawEvents:
      svs.sport.oddsetCommon.common.getMostPlayedDrawEvents,
      getDrawEventsByFilter:
      svs.sport.oddsetCommon.common.getDrawEventsByFilter
    };
  }
})(svs);

 })(window);